import React from 'react'
import { BaseView } from '../base'
import { responsiveAdapter } from '@/utils'

interface LinearGradientProps {
  colors: string[]
  locations?: number[]
  start?: { x: number; y: number }
  end?: { x: number; y: number }
  children?: React.ReactNode
  style?: React.CSSProperties
  // Свойства как в RN BaseLinearGradientView
  circle?: boolean
  circleSize?: number
  center?: boolean
}

export const LinearGradient: React.FC<LinearGradientProps> = ({
  colors,
  locations = [0, 1],
  start = { x: 0, y: 0 },
  end = { x: 1, y: 1 },
  children,
  style,
  circle = false,
  circleSize = 24,
  center = false,
}) => {
  // Создаем CSS градиент
  const createGradient = () => {
    // Конвертируем направление из RN формата в CSS
    const angle =
      Math.atan2(end.y - start.y, end.x - start.x) * (180 / Math.PI) + 90

    // Создаем color stops с locations
    const colorStops = colors
      .map((color, index) => {
        // Используем предоставленные locations или равномерное распределение
        const location =
          locations[index] !== undefined
            ? locations[index]
            : index / (colors.length - 1)
        return `${color} ${location * 100}%`
      })
      .join(', ')

    return `linear-gradient(${angle}deg, ${colorStops})`
  }

  const baseStyle: React.CSSProperties = {
    background: createGradient(),
    ...(circle && {
      width: responsiveAdapter(circleSize),
      height: responsiveAdapter(circleSize),
      borderRadius: responsiveAdapter(circleSize) / 2,
    }),
    ...(center && {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    ...style,
  }

  return <BaseView style={baseStyle}>{children}</BaseView>
}
